var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7887 28.0859C8.55374 28.0859 5.53817 27.145 3 25.5216C5.15499 25.661 8.95807 25.3271 11.3236 23.0707C7.76508 22.9074 6.16026 20.1782 5.95094 19.0119C6.25329 19.1285 7.6953 19.2685 8.50934 18.9419C4.4159 17.9156 3.78793 14.3233 3.92748 13.2269C4.695 13.7634 5.99745 13.95 6.50913 13.9034C2.69479 11.1742 4.06703 7.0687 4.74151 6.18229C7.47882 9.9746 11.5812 12.1045 16.6564 12.223C16.5607 11.8033 16.5102 11.3664 16.5102 10.9176C16.5102 7.69685 19.1134 5.08594 22.3247 5.08594C24.0025 5.08594 25.5144 5.79869 26.5757 6.93878C27.6969 6.67604 29.3843 6.06101 30.2092 5.52914C29.7934 7.02204 28.4989 8.26743 27.7159 8.72901C27.7224 8.74472 27.7095 8.71324 27.7159 8.72901C28.4037 8.62497 30.2648 8.26731 31 7.76849C30.6364 8.60719 29.264 10.0017 28.1377 10.7824C28.3473 20.024 21.2765 28.0859 11.7887 28.0859Z",
    fill: "#47ACDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.164ec7f5d41650c9fb2410fd8a979f5a.svg";
export { ForwardRef as ReactComponent };